import React from "react";
//import {players} from "./CourseInfo"
import { useStateValue } from "./StateProvider";
import "./Player.css";
//const player(num)= players.find(x => x.id === num)

function Player({ id }) {
  const [{ players }] = useStateValue();

  const player = players.find((s) => s.id === id);

  return (
    <div className="player__in">
      <div className="player">
      {player.first} {player.last}
      </div>
      <div className="handicap">
        {player.HC}
      </div>
    </div>
  );
}

export default Player;
